import { Component, OnInit } from '@angular/core';
import { BannerComponent } from '../components/banner/banner.component';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-generic-error',
  standalone: true,
  imports: [BannerComponent, TranslatePipe],
  templateUrl: './generic-error.component.html',
  styleUrl: './generic-error.component.scss'
})
export class GenericErrorComponent implements OnInit {

  constructor(private router: Router) {}

  ngOnInit() {
    document.getElementById('generic-error-header')?.focus();
  }

  onBack() {
    this.router.navigate(['/']);
  }
}
